import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Plantillas de planes listos',
    desc: 'Estructuras base para diferentes objetivos (hipertrofia, definición, mantenimiento) listas para adaptar a tus pacientes.',
    price: '$12.000'
  }, {
    num: '02',
    title: 'Guía rápida de suplementación',
    desc: 'Resumen práctico con dosis, timing y nivel de evidencia de los suplementos más utilizados en el deporte.',
    price: '$15.000'
  }, {
    num: '03',
    title: 'Formularios y fichas de consulta',
    desc: 'Documentos listos para anamnesis deportiva, registro de entrenamiento y seguimiento de evolución.',
    price: '$10.000'
  }, {
    num: '04',
    title: 'Checklist de evaluación corporal',
    desc: 'Paso a paso para no olvidarte de ninguna medida antropométrica clave y cómo interpretar los resultados.',
    price: '$11.000'
  }, {
    num: '05',
    title: 'Recetario fitness alto en proteína',
    desc: 'Opciones prácticas, ricas y fáciles de preparar para entregar a tus pacientes y mejorar su adherencia.',
    price: '$13.000'
  }, {
    num: '06',
    title: 'Informe y seguimiento para pacientes (Tiempo y Agenda)',
    desc: 'Cómo ordenar tu semana y tu sistema de atención para no "vivir trabajando" y entregar valor real.',
    price: '$9.000'
  }];
  return <section className="pt-5 pb-8 px-3 bg-black" data-id="element-36">
      <div className="max-w-5xl mx-auto" data-id="element-37">
        <FadeIn className="text-center mb-6" data-id="element-38">
          <h2 className="font-display text-2xl md:text-4xl font-bold text-white mb-2" data-id="element-39">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="text-sm font-medium text-accent" data-id="element-40">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-41">
          {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-accent/[0.04] border border-accent/25 rounded-lg p-4 flex flex-col h-full hover:border-accent/50 transition-colors relative overflow-hidden group" data-id="element-42">
              <div className="absolute top-0 right-0 w-20 h-20 bg-accent/5 rounded-bl-full -mr-6 -mt-6 transition-transform group-hover:scale-110" data-id="element-43" />

              <div className="flex items-center justify-between mb-3 relative z-10" data-id="element-44">
                <span className="text-xl font-black text-white/10 font-display" data-id="element-45">
                  {bonus.num}
                </span>
                <span className="bg-accent/10 text-accent text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider border border-accent/20" data-id="element-46">
                  Bono {parseInt(bonus.num)}
                </span>
              </div>

              <h3 className="text-sm font-bold text-white mb-1.5 relative z-10" data-id="element-47">
                {bonus.title}
              </h3>

              <p className="text-white/60 text-xs leading-relaxed mb-4 flex-1 relative z-10" data-id="element-48">
                {bonus.desc}
              </p>

              <div className="flex items-center justify-between pt-2 border-t border-white/10 relative z-10" data-id="element-49">
                <span className="text-white/40 line-through text-xs font-medium" data-id="element-50">
                  {bonus.price}
                </span>
                <span className="bg-accent text-black font-black text-xs px-2.5 py-0.5 rounded-full uppercase tracking-wide" data-id="element-51">
                  Gratis
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="text-center mt-5" data-id="element-52">
          <p className="text-white/50 italic max-w-2xl mx-auto text-xs" data-id="element-53">
            Todo esto viene incluido hoy para que empieces con más herramientas,
            más seguridad y más valor percibido en tu consulta clínica.
          </p>
        </FadeIn>
      </div>
    </section>;
}